import { AnimatedSection } from "./AnimatedSection";
import { CheckCircle } from "lucide-react";

const changes = [
  { before: "Guesswork", after: "Pricing is clearer" },
  { before: "Scattered", after: "Supply is structured" },
  { before: "Delayed", after: "Deals move faster" },
  { before: "Random", after: "Participants are verified" },
];

export function ValueProp() {
  return (
    <section className="py-24 md:py-32 bg-[#09120D]" data-testid="value-prop-section">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection>
          <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
            What This Changes
          </p>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white max-w-3xl">
            Introducing structure into trade
          </h2>
          <p className="mt-6 text-[#A1B2A8] text-base lg:text-lg max-w-2xl leading-relaxed">
            Delta GreenX creates a controlled trade environment where:
          </p>
        </AnimatedSection>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {changes.map((item, i) => (
            <AnimatedSection key={i} delay={i * 0.1}>
              <div className="bg-[#050A07] border border-[#1A2E22] p-8 md:p-10 hover:border-[#22C55E]/50 transition-colors duration-300">
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-5 h-5 text-[#22C55E] mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-white font-['Outfit'] font-semibold text-base">
                      {item.after}
                    </p>
                    <p className="mt-1 text-[#A1B2A8]/60 text-sm line-through">
                      not {item.before.toLowerCase()}
                    </p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
